import { render } from "./PetitionBody.vue?vue&type=template&id=f5978456"
import script from "./PetitionBody.vue?vue&type=script&lang=js"
export * from "./PetitionBody.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/src/public-poll/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__